import React, { useEffect, useState, Fragment } from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";

function DetailVacant() {
  const [item, setitem] = useState();
  const params = useParams();

  return (
    <div className="vacantes perfil-empresa profile">
      <div className="container">
        <div className="row">
          <div className="box">
            <div className="one-half">
              <div className="head">
                <div className="company__wrapper">
                  <div className="logo">
                    <img
                      src={
                        item.companyDTOResponse.fotoPerfilEmpresa
                      }
                    ></img>
                  </div>

                  <div className="content">
                    <div className="cargo">{item.companyDTOResponse.cargo}</div>
                    <div className="lugar">{item.companyDTOResponse.name}</div>
                    <div className="cuidad">Managua</div>
                  </div>

                  <div className="aplicar">
                    <a href="#" className="btn btn--gradient">
                      Ver
                    </a>
                  </div>
                </div>
              </div>
              <div className="body">
                <div className="left-side">
                  <ul>
                    <li>
                      Publicado: {item.companyDTOResponse.diasTranscurridos}
                    </li>
                    <li>Tipo: {item.companyDTOResponse.tipoEmpleo}</li>
                    <li>Expereiencia: Intermedia</li>
                  </ul>
                </div>
                <div className="right-side">
                  <ul>
                    <li>
                      <i className="fa fa-eye" aria-hidden="true"></i>{" "}
                      Visualizaciones: 340{" "}
                      <a href="#">
                        <i className="fa fa-share-alt" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <i className="fa fa-folder-open" aria-hidden="true"></i>{" "}
                      Aplicando: 10{" "}
                      <a href="#">
                        <i className="fa fa-bookmark" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer">
                <div className="actitudes">
                  <div className="left-content">
                    Habilidades: 2 / 10
                    <span>Liderazgo - Comunicación - Innovacions</span>
                  </div>
                  <div className="right-content">
                    <a href="#">Salario: USD 1500 Mens.</a>
                  </div>
                </div>
                <div className="bottom-content">
                  <ul>
                    <li>
                      <a href="#">Pide una Recomendación</a>
                    </li>
                    <li>
                      <a href="#">Referir a contacto</a>
                    </li>
                    <li>
                      <a href="#">Pregúntanos</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">First</th>
                <th scope="col">Last</th>
                <th scope="col">Handle</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
              </tr>
              <tr>
                <th scope="row">2</th>
                <td>Jacob</td>
                <td>Thornton</td>
                <td>@fat</td>
              </tr>
              <tr>
                <th scope="row">3</th>
                <td colspan="2">Larry the Bird</td>
                <td>@twitter</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DetailVacant;
